import { useMemo } from 'react';

import useGetMagazinesInfiniteQuery from '@/hooks/magazine/mobile/useGetMagazinesInfiniteQuery';
import { magazinesService } from '@/services/magazine/mobile';
import { MagazineType } from '@/types/magazine';

const FAQ_SIZE = 20;
const useGetInfiniteFaq = () => {
  const {
    data: faqsData,
    isLoading: isFaqsLoading,
    hasNextPage: hasFaqsNextPage,
    fetchNextPage: fetchFaqsNextPage,
  } = useGetMagazinesInfiniteQuery(
    {
      magazineCursorPageRequestInput: {
        size: FAQ_SIZE,
        contentType: MagazineType.FAQ,
      },
    },
    {
      select: (data) => {
        return {
          pages: magazinesService(data.pages),
          pageParams: data.pageParams,
        };
      },
    },
  );

  const faqs = useMemo(() => {
    if (!faqsData?.pages) {
      return [];
    }
    return faqsData?.pages
      .flatMap((page) => page)
      .map((faq) => ({
        title: faq.title,
        magazinePid: faq.magazinePid,
        mobileTitle: faq.title,
        image: '',
        date: faq.createdDate,
        description: faq.description,
        mobileDescription: faq.description,
      }));
  }, [faqsData?.pages]);

  return {
    faqs,
    isFaqsLoading,
    hasFaqsNextPage,
    fetchFaqsNextPage,
  };
};

export default useGetInfiniteFaq;
